module.exports = __webpack_public_path__ + "static/media/vetor_login-user.04bb5a92.svg";